import { accessRole } from "../../../../helpers/access_role";
import React, { useState, Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";
import { Link, useHistory, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import { ConfirmAlert } from "../../../../helpers/ui/alert";

import apiResponse from "../../../../services/apiResponse";

import ApproveBloc from "./Blocs/ApproveBloc";
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";
import moment from "moment";

import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import { Preview } from "../../../../helpers/ui/FileInput";

class IndexView extends Component {
  approveBloc = new ApproveBloc();
  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_uuid
    : "";
  peg_name = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_full_name
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_full_name
    : "";
  employee_current_position_name = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_current_position_name
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_current_position_name
    : "";

  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_uuid
    : "";

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      optionStatusApproval: [
        { label: "Disetujui", value: 1 },
        { label: "Ditolak", value: 2 },
      ],
      isLocal: 1,
    };
  }

  titleCase = (s) =>
    s.replace(/^_*(.)|_+(.)/g, (s, c, d) =>
      c ? c.toUpperCase() : " " + d.toUpperCase()
    );

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  submitData = async () => {
    await this.approveBloc.fetchApprove(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        employee_uuid: this.peg_uuid,
        uuid: this.state.detail.family_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.approveBloc.approveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.approveBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response_current = result.data.response.current;
            let response_history = result.data.response.history;
            this.setState({
              detail: response_current,
              dataForm: {
                status: 1,
                uuid: response_current.family_uuid,
              },
              history: response_history,
              documents: response_current?.documents,
              isLocal:
                response_current.family_place_of_birth_national == "Luar Negeri"
                  ? 0
                  : 1,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    const queryParams = new URLSearchParams(this.props.location.search);
    this.approveBloc.fetchDetail({ uuid: queryParams.get("uuid"), history: 1 });

    /* 
            If Administrator
            Set Employee Selected on localstorage by Notification Click 
        */
    try {
      let causer = queryParams.get("causer");

      if (causer != null) {
        let arrCauser = atob(causer).split("|");

        let dataUser = {
          employee_uuid: arrCauser[1],
          employee_name: arrCauser[0],
          employee_current_position_name: arrCauser[2],
          employee_nip: arrCauser[3],
        };
        localStorage.setItem("employeeSelected", JSON.stringify(dataUser));
        //console.log(arrCauser);
      }
    } catch (error) {}
  }

  componentWillUnmount() {
    this.approveBloc.detailChannel.unsubscribe();
    this.approveBloc.approveChannel.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <PegawaiSideBar active="riwayat_nikah" />

              <Card className="pegawai-rightbar">
                <AvForm
                  className="needs-validation"
                  onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                >
                  <CardBody>
                    <CardTitle>Approve Data Suami/Istri</CardTitle>
                    {/* <CardSubtitle className="mb-3">
                                            Informasi Detail Data Anak
                                        </CardSubtitle> */}
                    <hr />
                    {this.state.history ? (
                      <Row className="mb-3">
                        <label className="col-md-3"></label>
                        <Col md="5">
                          <strong> Data Baru </strong>
                        </Col>
                        <Col md="4">
                          <strong className="text-danger"> Data Lama </strong>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                    <Row className="mb-3">
                      <label className="col-md-3">Jenis Pekerjaan</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.family_spouse_job_type_name !==
                            ""
                              ? this.state.detail.family_spouse_job_type_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.family_spouse_job_type_name !==
                            ""
                              ? this.state.history.family_spouse_job_type_name
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    {this.state.detail?.family_spouse_job_type == "1" ||
                    this.state.detail?.family_spouse_job_type == "2" ? (
                      <>
                        <Row className="mb-3">
                          <label className="col-md-3">NIP</label>
                          <Col md="5">
                            {this.state.detail ? (
                              <>
                                {this.state.detail.family_profession_pns_nip !==
                                ""
                                  ? this.state.detail.family_profession_pns_nip
                                  : "-"}
                              </>
                            ) : (
                              <Shimmer>
                                <div style={{ width: 200, height: 15 }}></div>
                              </Shimmer>
                            )}
                          </Col>
                          <Col md="4">
                            {this.state.history ? (
                              <>
                                {this.state.history
                                  .family_profession_pns_nip !== ""
                                  ? this.state.history.family_profession_pns_nip
                                  : "-"}
                              </>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>

                        {this.state.pnsStatus !== "1" && (
                          <Row className="mb-3">
                            <label className="col-md-3"></label>

                            {/* KOLOM DETAIL */}
                            <Col md="5" style={{ paddingTop: "8px" }}>
                              {this.state.detail ? (
                                <>
                                  <AvInput
                                    type="checkbox"
                                    name="statusTunjanganDetail"
                                    id="fieldStatusTunjanganDetail"
                                    defaultChecked={
                                      Number(
                                        this.state.detail
                                          .family_is_dependent_allowance
                                      ) === 1
                                    }
                                    disabled
                                  />
                                  <span style={{ marginLeft: "8px" }}>
                                    Apakah pasangan sudah dapat tunjangan
                                    keluarga di tempat lain?
                                  </span>
                                </>
                              ) : (
                                <Shimmer>
                                  <div style={{ width: 200, height: 15 }}></div>
                                </Shimmer>
                              )}
                            </Col>

                            {/* KOLOM HISTORY */}
                            <Col md="4" style={{ paddingTop: "8px" }}>
                              {this.state.history ? (
                                <>
                                  <AvInput
                                    type="checkbox"
                                    name="statusTunjanganHistory"
                                    id="fieldStatusTunjanganHistory"
                                    defaultChecked={
                                      Number(
                                        this.state.history
                                          .family_is_dependent_allowance
                                      ) === 1
                                    }
                                    disabled
                                  />
                                  <span style={{ marginLeft: "8px" }}>
                                    Apakah pasangan sudah dapat tunjangan
                                    keluarga di tempat lain?
                                  </span>
                                </>
                              ) : (
                                ""
                              )}
                            </Col>
                          </Row>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                    {this.state.detail?.family_spouse_job_type == "3" && (
                      <Row className="mb-3">
                        <label className="col-md-3">Pekerjaan</label>
                        <Col md="5">
                          {this.state.detail ? (
                            <>
                              {this.state.detail.family_profession !== ""
                                ? this.state.detail.family_profession
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: 200, height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                        <Col md="4">
                          {this.state.history ? (
                            <>
                              {this.state.history.family_profession !== ""
                                ? this.state.history.family_profession
                                : "-"}
                            </>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    )}
                    <Row className="mb-3">
                      <label className="col-md-3">Nama Suami/Istri :</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.family_name !== ""
                              ? this.state.detail.family_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.family_name !== ""
                              ? this.state.history.family_name
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">
                        Nomor Induk Kependudukan
                      </label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.family_identity_number !== ""
                              ? this.state.detail.family_identity_number
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Nomor Kartu Keluarga</label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.familty_family_card_number !== ""
                              ? this.state.detail.familty_family_card_number
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">
                        Lahir Dalam Negeri / Luar Negeri
                      </label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail
                              .family_place_of_birth_national !== ""
                              ? this.state.detail.family_place_of_birth_national
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 250, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history
                              .family_place_of_birth_national !== ""
                              ? this.state.history
                                  .family_place_of_birth_national
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Negara Lahir</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail
                              .family_place_of_birth_country_name !== ""
                              ? this.state.detail
                                  .family_place_of_birth_country_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 250, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history
                              .family_place_of_birth_country_name !== ""
                              ? this.state.history
                                  .family_place_of_birth_country_name
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    {}

                    <Row
                      className="mb-3"
                      style={this.state.isLocal == 0 ? { display: "none" } : {}}
                    >
                      <label className="col-md-3">Provinsi Lahir</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail
                              .family_place_of_birth_province_name !== ""
                              ? this.state.detail
                                  .family_place_of_birth_province_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 250, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history
                              .family_place_of_birth_province_name !== ""
                              ? this.state.history
                                  .family_place_of_birth_province_name
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    {/* Dalam Negeri  */}
                    <Row
                      className="mb-3"
                      style={this.state.isLocal == 0 ? { display: "none" } : {}}
                    >
                      <label className="col-md-3">Kota Lahir</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail
                              .family_place_of_birth_city_name !== ""
                              ? this.state.detail
                                  .family_place_of_birth_city_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history
                              .family_place_of_birth_city_name !== ""
                              ? this.state.history
                                  .family_place_of_birth_city_name
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <Row
                      className="mb-3"
                      style={this.state.isLocal == 1 ? { display: "none" } : {}}
                    >
                      <label className="col-md-3">Kota Lahir</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail
                              .family_place_of_birth_city_text !== ""
                              ? this.state.detail
                                  .family_place_of_birth_city_text
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history
                              .family_place_of_birth_city_text !== ""
                              ? this.state.history
                                  .family_place_of_birth_city_text
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Tanggal Lahir</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.family_date_of_birth !== ""
                              ? this.dateParse(
                                  this.state.detail.family_date_of_birth
                                )
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.family_date_of_birth !== ""
                              ? this.dateParse(
                                  this.state.history.family_date_of_birth
                                )
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Status</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail
                              .family_relationship_status_name !== ""
                              ? this.state.detail
                                  .family_relationship_status_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history
                              .family_relationship_status_name !== ""
                              ? this.state.history
                                  .family_relationship_status_name
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Pendidikan</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.family_education_name !== ""
                              ? this.state.detail.family_education_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.family_education_name !== ""
                              ? this.state.history.family_education_name
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Jurusan</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.family_major !== ""
                              ? this.state.detail.family_major
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.family_major !== ""
                              ? this.state.history.family_major
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Tempat Kerja</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.family_profession_place !== ""
                              ? this.state.detail.family_profession_place
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.family_profession_place !== ""
                              ? this.state.history.family_profession_place
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Sebagai Ahli Waris</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.family_spouse_is_heir_name !== ""
                              ? this.state.detail.family_spouse_is_heir_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.family_spouse_is_heir_name !==
                            ""
                              ? this.state.history.family_spouse_is_heir_name
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    {this.state.detail?.family_spouse_is_heir == 1 && (
                      <Fragment>
                        <Row className="mb-3">
                          <label className="col-md-3 col-form-label">
                            Sudah Dibayar :{" "}
                          </label>
                          <label className="col-md-5 col-form-label">
                            {this.state.detail?.family_spouse_is_pay_name}{" "}
                          </label>
                          <label className="col-md-4 col-form-label">
                            {this.state.history?.family_spouse_is_pay_name}{" "}
                          </label>
                        </Row>
                        {this.state.detail?.family_spouse_is_pay == 1 && (
                          <Row className="mb-3">
                            <label className="col-md-3 col-form-label">
                              Bulan Dibayar :{" "}
                            </label>
                            <label className="col-md-5 col-form-label">
                              {this.state.detail?.family_spouse_pay_date}
                            </label>
                            <label className="col-md-4 col-form-label">
                              {this.state.history?.family_spouse_pay_date}
                            </label>
                          </Row>
                        )}
                      </Fragment>
                    )}

                    <Row className="mb-3">
                      <hr />
                      <label className="col-md-3">#Keterangan Nikah</label>
                      <hr />
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Nikah Ke</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.family_spouse_marriage_count !==
                            ""
                              ? this.state.detail.family_spouse_marriage_count
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.family_spouse_marriage_count !==
                            ""
                              ? this.state.history.family_spouse_marriage_count
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Tanggal Nikah</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.family_spouse_wedding_date !== ""
                              ? this.dateParse(
                                  this.state.detail.family_spouse_wedding_date
                                )
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history.family_spouse_wedding_date !==
                            ""
                              ? this.dateParse(
                                  this.state.history.family_spouse_wedding_date
                                )
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Suami/Istri ke</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail
                              .family_spouse_husband_or_wife_to !== ""
                              ? this.state.detail
                                  .family_spouse_husband_or_wife_to
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history
                              .family_spouse_husband_or_wife_to !== ""
                              ? this.state.history
                                  .family_spouse_husband_or_wife_to
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">No Buku/Akta Nikah</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail
                              .family_spouse_marriage_book_number !== ""
                              ? this.state.detail
                                  .family_spouse_marriage_book_number
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history
                              .family_spouse_marriage_book_number !== ""
                              ? this.state.history
                                  .family_spouse_marriage_book_number
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    {/* <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kartu Nikah
                                            </label>
                                            <Col md="5">
                                                
                                            </Col>
                                            <Col md="4">
                                                
                                            </Col>
                                        </Row> */}

                    {this.state.detail?.family_relationship_status_name !=
                      "Nikah" && (
                      <>
                        <Row className="mb-3">
                          <hr />
                          <label className="col-md-3">#Keterangan Cerai</label>
                          <hr />
                        </Row>
                        <Row className="mb-3">
                          <label className="col-md-3">Tanggal Cerai</label>
                          <Col md="5">
                            {this.state.detail ? (
                              <>
                                {this.state.detail
                                  .family_spouse_divorce_date !== ""
                                  ? this.dateParse(
                                      this.state.detail
                                        .family_spouse_divorce_date
                                    )
                                  : "-"}
                              </>
                            ) : (
                              <Shimmer>
                                <div style={{ width: 200, height: 15 }}></div>
                              </Shimmer>
                            )}
                          </Col>
                          <Col md="4">
                            {this.state.history ? (
                              <>
                                {this.state.history
                                  .family_spouse_divorce_date !== ""
                                  ? this.dateParse(
                                      this.state.history
                                        .family_spouse_divorce_date
                                    )
                                  : "-"}
                              </>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <label className="col-md-3">No SK Cerai</label>
                          <Col md="5">
                            {this.state.detail ? (
                              <>
                                {this.state.detail
                                  .family_spouse_divorce_number_decree !== ""
                                  ? this.state.detail
                                      .family_spouse_divorce_number_decree
                                  : "-"}
                              </>
                            ) : (
                              <Shimmer>
                                <div style={{ width: 200, height: 15 }}></div>
                              </Shimmer>
                            )}
                          </Col>
                          <Col md="4">
                            {this.state.history ? (
                              <>
                                {this.state.history
                                  .family_spouse_divorce_number_decree !== ""
                                  ? this.state.history
                                      .family_spouse_divorce_number_decree
                                  : "-"}
                              </>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <label className="col-md-3">TMT SK Cerai</label>
                          <Col md="5">
                            {this.state.detail ? (
                              <>
                                {this.state.detail
                                  .family_spouse_divorce_tmt_date !== ""
                                  ? this.dateParse(
                                      this.state.detail
                                        .family_spouse_divorce_tmt_date
                                    )
                                  : "-"}
                              </>
                            ) : (
                              <Shimmer>
                                <div style={{ width: 200, height: 15 }}></div>
                              </Shimmer>
                            )}
                          </Col>
                          <Col md="4">
                            {this.state.history ? (
                              <>
                                {this.state.history
                                  .family_spouse_divorce_tmt_date !== ""
                                  ? this.dateParse(
                                      this.state.history
                                        .family_spouse_divorce_tmt_date
                                    )
                                  : "-"}
                              </>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                      </>
                    )}

                    <hr />

                    <Row className="mb-3">
                      <label className="col-md-3">No Karis / Karsu</label>
                      <Col md="5">
                        {this.state.detail ? (
                          <>
                            {this.state.detail
                              .family_spouse_karis_karsu_number !== ""
                              ? this.state.detail
                                  .family_spouse_karis_karsu_number
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 200, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.history ? (
                          <>
                            {this.state.history
                              .family_spouse_karis_karsu_number !== ""
                              ? this.state.history
                                  .family_spouse_karis_karsu_number
                              : "-"}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                                            <label className="col-md-3">
                                                File Pendukung
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>
                                                            {this.state.detail.document != null ?  
                                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document?.documents_path}>
                                                                    Download <i className="fa fa-download ms-1"></i>
                                                                </a>
                                                            : '-'}
                                                        </>
                                                    :
                                                        <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>
                                                        {this.state.history.document != null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.history.document?.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    ""
                                            }
                                            </Col>
                                        </Row> */}

                    <hr />

                    {this.state.documents?.map((val, i) => {
                      return (
                        <Row className="mb-3">
                          <label className="col-md-3">
                            {this.titleCase(val.family_document_type)}
                          </label>
                          <Col md="9">
                            {val.document ? (
                              <Preview value={val.document} />
                            ) : (
                              <Shimmer>
                                <div style={{ width: 68, height: 15 }}></div>
                              </Shimmer>
                            )}
                          </Col>
                        </Row>
                      );
                    })}

                    <hr />

                    <Row className="mb-3">
                      <label className="col-md-3">
                        Status Approval <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <CustomSelect
                          name="status_approval"
                          errorMessage="Pilih Status Approval"
                          options={this.state.optionStatusApproval}
                          placeholder="Pilih Status Approval"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="status_approval_description"
                        className="col-md-3 col-form-label"
                      >
                        Keterangan Approval{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="6">
                        <AvField
                          name="status_approval_description"
                          placeholder="Keterangan Approval..."
                          type="textarea"
                          errorMessage="Masukkan Keterangan Approval"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="status_approval_description"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>{" "}
                        <Link to="/kepegawaian/home.html?riwayat_nikah">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                  </CardBody>
                </AvForm>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan melakukan approval untuk data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/home.html?riwayat_nikah" />
        ) : null}
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
